'use strict';Object.defineProperty(exports,'__esModule',{value:!0});var _shortid=require('shortid'),_shortid2=_interopRequireDefault(_shortid);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var generateUniqueId=function(){var name=0<arguments.length&&arguments[0]!==void 0?arguments[0]:'id';return name+'-'+_shortid2.default.generate()};exports.default=generateUniqueId;


/** WEBPACK FOOTER **
 ** ./~/@vitalsource/vstui/utils/generateUniqueId.js
 **/